import { FETCH_CORE } from '../actions';

export default (state = {}, action) => {
    switch (action.type) {
        case FETCH_CORE: 
            return action.payload.data;
        default: 
            return state;
    }
}




// WEBPACK FOOTER //
// ./src/client/reducers/coreReducer.js